export default __webpack_public_path__ + "static/media/image-victor-glover.8a9a5424.png";